// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oYfT","icon":"styles_icon__2_bSS"};